import { constants } from "../constants/redux-constants";

export const set_current_subscription = (payload) => {
  return {
    type: constants.SUBSCRIPTION.SET_CURRENT_SUBSCRIPTION,
    payload,
  };
};

export const set_available_plans=(payload)=>{
  return{
    type:constants?.SUBSCRIPTION?.SET_AVAILABLE_PLANS,
    payload,
  }
}

export const reset_subscription=()=>{
  return{
    type:constants?.SUBSCRIPTION?.RESET_SUBSCRIPTION,
  }
}
